import { render, staticRenderFns } from "./PedidoCuentaUpdate.vue?vue&type=template&id=4f96e91c&scoped=true"
import script from "./PedidoCuentaUpdate.vue?vue&type=script&lang=js"
export * from "./PedidoCuentaUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f96e91c",
  null
  
)

export default component.exports